import script from "./PodcastAdminShowsList.vue?vue&type=script&setup=true&lang=js"
export * from "./PodcastAdminShowsList.vue?vue&type=script&setup=true&lang=js"

import "./PodcastAdminShowsList.vue?vue&type=style&index=0&id=3c9a22c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c9a22c6"]])

export default __exports__